import React, { useEffect } from "react";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import "./Testimonials.css";

const testimonials = [
  {
    name: "Nery Giron",
    text: "Melodia Music rerouted our church audio, recommended speaker and subwoofer placement, and the in-house mix sounds amazing now. They’re so knowledgeable I signed up for audio-engineering lessons too — totally worth it.",
  },
  {
    name: "David Ulloa",
    text: "I’d never taken music lessons before. Ivan is patient and attentive to detail; with his help I can read sheet music and I’ve played my first songs.",
  },
  {
    name: "Pastor CJ",
    text: "Ivan is an amazing piano player and an even better teacher. He turns theory into clear, usable steps at the keyboard — our team has grown a ton.",
  },
  {
    name: "David Alvarez",
    text: "Ivan blows my mind with how much he knows and how advanced his playing is. What I love most is how he explains complex theory in a way that finally clicks.",
  },
  {
    name: "Caleb Barrios",
    text: "Ivan makes learning fun — he tailors lessons around the songs I want to learn, and I’m seeing progress every week.",
  },
  {
    name: "Axel",
    text: "I was nervous to start bass, but Ivan was very patient and pushed me out of my comfort zone. I’m locking in grooves I never thought I could.",
  },
  {
    name: "Pablo",
    text: "Ivan helped me move past basic chords into fingerpicking for a worship setting. I’m really happy with the results and excited to keep going.",
  },
  {
    name: "Pastor Diarte",
    text: "Truly a big help to our sound team. Melodia Music is excellent for audio services — I’m grateful for their work.",
  },
];

const Testimonials = () => {
  useEffect(() => {
    new Swiper(".mySwiper", {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      autoplay: { delay: 5000 },
      pagination: { el: ".swiper-pagination", clickable: true },
      breakpoints: {
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
    });
  }, []);

  return (
    <section id="testimonials" className="testimonials">
      <h2 className="testimonial-heading">What My Students Say</h2>
      <div className="swiper mySwiper">
        <div className="swiper-wrapper">
          {testimonials.map((t, i) => (
            <div className="swiper-slide" key={i}>
              <div className="testimonial-card">
                <p className="testimonial-text">"{t.text}"</p>
                <p className="testimonial-name">– {t.name}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="swiper-pagination"></div>
      </div>
    </section>
  );
};

export default Testimonials;
